"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var reporting_service_1 = require("./reporting.service");
var report_meta_model_1 = require("./model/reporting/report-meta.model");
var report_meta_filters_root_operator_children_model_1 = require("./model/reporting/report-meta-filters-root-operator-children.model");
var helper_util_1 = require("./util/helper.util");
var report_meta_filters_root_operator_model_1 = require("./model/reporting/report-meta-filters-root-operator.model");
var report_meta_filters_model_1 = require("./model/reporting/report-meta-filters.model");
var report_request_body_model_1 = require("./model/reporting/report-request-body.model");
var core_1 = require("@angular/core");
var report_data_to_tracking_data_converter_1 = require("./converter/report-data-to-tracking-data.converter");
var IndicatorCalculationServiceImpl = /** @class */ (function () {
    function IndicatorCalculationServiceImpl(reportingService) {
        this.reportingService = reportingService;
    }
    IndicatorCalculationServiceImpl_1 = IndicatorCalculationServiceImpl;
    IndicatorCalculationServiceImpl.prototype.calculate = function (indicatorId, frequency, measure, rFItemId, rFItemLevel, iFSystemName, iFItemId, languageId, disGroupId, trackingToSave, dataPointId) {
        var reqBody = new report_request_body_model_1.ReportRequestBody(IndicatorCalculationServiceImpl_1.generateReportMeta(indicatorId, frequency, measure, rFItemId, rFItemLevel, iFSystemName, iFItemId, languageId), trackingToSave);
        return this.reportingService.getIndicatorReport(reqBody, indicatorId, rFItemId, rFItemLevel, iFSystemName, iFItemId)
            .map(function (res) { return new report_data_to_tracking_data_converter_1.ReportDataToTrackingDataConverter(res, frequency, measure, disGroupId).convert(dataPointId); });
    };
    IndicatorCalculationServiceImpl.generateReportMeta = function (indicatorId, frequency, measure, rFItemId, rFItemLevel, iFSystemName, iFItemId, languageId) {
        var categorySystemNames = [];
        var children = [];
        if (iFSystemName && iFItemId) {
            categorySystemNames.push(iFSystemName);
            children.push(new report_meta_filters_root_operator_children_model_1.ReportMetaFiltersRootOperatorChildren('filter', 'in', false, false, iFSystemName, [iFItemId]));
        }
        if (rFItemId && rFItemLevel) {
            var name_1 = 'RFLevel' + rFItemLevel;
            categorySystemNames.push(name_1);
            children.push(new report_meta_filters_root_operator_children_model_1.ReportMetaFiltersRootOperatorChildren('filter', 'in', false, false, name_1, [rFItemId]));
        }
        categorySystemNames.push('Indicator');
        children.push(new report_meta_filters_root_operator_children_model_1.ReportMetaFiltersRootOperatorChildren('filter', 'in', false, false, 'Indicator', [indicatorId]));
        if (frequency && frequency !== 1) {
            categorySystemNames.push(helper_util_1.Helper.getFrequencyNameById(frequency));
        }
        var rootOperator = new report_meta_filters_root_operator_model_1.ReportMetaFiltersRootOperator('operator', 'and', children);
        var filters = new report_meta_filters_model_1.ReportMetaFilters(rootOperator);
        return new report_meta_model_1.ReportMeta(categorySystemNames, measure.valueOf(), filters, true, false, languageId);
    };
    IndicatorCalculationServiceImpl = IndicatorCalculationServiceImpl_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [reporting_service_1.ReportingService])
    ], IndicatorCalculationServiceImpl);
    return IndicatorCalculationServiceImpl;
    var IndicatorCalculationServiceImpl_1;
}());
exports.IndicatorCalculationServiceImpl = IndicatorCalculationServiceImpl;
//# sourceMappingURL=indicator-calculation.service-impl..js.map